import { FontIcon } from 'office-ui-fabric-react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import * as React from 'react';
import { IModalDialog } from '../../../models/IModalDialog';
import "../captcha.css";
import { IResetPasswordProps } from './IResetPasswordProps';
import { IResetPasswordState } from './IResetPasswordState';
initializeIcons();

const getStyles = () => {
    return {
        root: {
            maxWidth: '300px',
            responsiveMode: true,
            color: '#005269'
        }
    }
};
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    width: "100%", fontSize: "13px", color: '#005269'
});
const topMsgPanel = mergeStyles({
    textAlign: "center", backgroundColor: "#006d79", color: "#FFFFFF", width: "100%", padding: "5px"
});
const successMsgPanel = mergeStyles({
    color: 'green', fontSize: "13px", textAlign: "center"
});
const errorMsgPanel = mergeStyles({
    color: '#be262c', fontSize: "12px", fontWeight: "400", textAlign: "center"
});
const iconPanel = mergeStyles({
    paddingRight: "3px"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
const topPanel = mergeStyles({
    justifyContent: "center", width: "100%", display: "flex", padding: "10px"
});
const captchPanel = mergeStyles({
    paddingTop: "20px", overflowX: "auto", overflowY: "hidden"
});
export default class ResetPassword extends React.Component<IResetPasswordProps, IResetPasswordState> {
    private EmailError: string;
    private dialog: IModalDialog;
    private recaptchaError: string;
    constructor(props: IResetPasswordProps, state: IResetPasswordState) {
        super(props);
        this.EmailError = '';
        this.recaptchaError = '';
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
        this.state = {
            loading: false,
            inputError: '',
            showError: false,
            isValidData: false,
            count: 2,
            siteKey: "",
            captchaToken: ""
        }
        window['getCaptchaResponse'] = this.getCaptchaResponse;
    }
    public async componentDidMount() {
        await this.loadSiteKey();
        this.onloadCallback();
    }
    private onloadCallback() {
        try {
            if (this.state.siteKey) {
                window['grecaptcha'].render('recaptchaResetPassword', {
                    'sitekey': this.state.siteKey,
                    'callback': this.getCaptchaResponse,
                    'theme': 'light'
                });
            }
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    private loadSiteKey = async (): Promise<void> => {
        try {
            let siteKey: string = await this.props.connectionContext.get("Register");
            this.setState((prevState: IResetPasswordState): IResetPasswordState => {
                prevState.siteKey = siteKey;
                return prevState;
            });
        } catch (exception) {
            this.setState((prevState: IResetPasswordState): IResetPasswordState => {
                prevState.isValidData = false;
                prevState.siteKey = "";
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                return prevState;
            });
        }
    }
    private getCaptchaResponse = async (token: string) => {
        if (token) {
            this.setState((prevState: IResetPasswordState): IResetPasswordState => {
                prevState.captchaToken = token;
                this.recaptchaError = '';
                return prevState;
            });
        }
    }
    public render(): React.ReactElement<IResetPasswordProps> {
        const { siteKey } = this.state;
        return (
            <div className={panel}>
                <div className={topMsgPanel}>
                    <h4><FontIcon iconName="Reset" className={iconPanel} />Reset Password</h4>
                </div>
                {
                    (!this.state.isValidData && this.state.showError && siteKey) && (
                        <div>
                            <div>
                                <p className={errorMsgPanel}><FontIcon iconName="Error" className={iconPanel} />Invalid email address/captcha!</p>
                            </div>
                        </div>)
                }
                {
                    (this.state.isValidData && !this.state.showError) && (
                        <div>
                            <div>
                                <p className={successMsgPanel}> <FontIcon iconName="Completed" className={iconPanel} />Password reset link has been sent to provided email.You will receive the email in 2-3 minutes. Click on the link in the mail to reset your password.</p>
                            </div>
                        </div>)
                }
                {
                    ((!this.state.isValidData || this.state.showError) && siteKey) && (
                        <div className={topPanel}>
                            <div>
                                <div><strong>Forgot your password?</strong></div>
                                <div>Please enter your registered email address. <br />We will send you an email to reset your password.</div>
                                <div>
                                    <TextField label="Email address" required placeholder="Email address" styles={getStyles}
                                        maxLength={320} value={this.state.email} onChange={this.getEmailValidationErrorText} errorMessage={this.EmailError} iconProps={{ iconName: 'PublicEmail' }} />
                                </div>
                                <div className={captchPanel}>
                                    <div id="recaptchaResetPassword">
                                    </div>
                                    <div>
                                        <span className={errorMsgPanel}>{this.recaptchaError}</span>
                                    </div>
                                </div>
                                <div>
                                    <br />
                                    <span className={errorMsgPanel}> * </span> Mandatory  <br />
                                    <p>  <PrimaryButton text="Send Link" data-automation-id="test" onClick={this.submitForm} className={submitButton} iconProps={{ iconName: 'Send' }} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
    private getEmailValidationErrorText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IResetPasswordState): IResetPasswordState => {
            let newEmailToResetPasswordFor: string = value || '';

            const re = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
            if (newEmailToResetPasswordFor.length < 1) {
                this.EmailError = 'Email address is Required.';
                prevState.email = undefined;
            }
            else if (!re.test(newEmailToResetPasswordFor)) {
                this.EmailError = 'Enter a valid Email address';
                prevState.email = newEmailToResetPasswordFor;
            }
            else {
                this.EmailError = '';
                prevState.email = newEmailToResetPasswordFor;
            }
            return prevState;
        });
    }
    private submitForm = async (): Promise<void> => {
        if (this.checkMandatoryFields()) {
            try {
                let sendPasswordResetLink = {
                    email: this.state.email,
                    captchaToken: this.state.captchaToken
                };
                await this.props.connectionContext.put("PasswordReset", sendPasswordResetLink);
                this.setState({ isValidData: true, showError: false });
            } catch (error) {
                this.setState({ isValidData: false, showError: true });
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                this.onloadCallback();
            }
        }
    }
    private checkMandatoryFields(): boolean {
        let validState: boolean = true;
        let captchatoken: boolean = this.state.captchaToken.toString().trim().length > 0;

        if (this.state.email === undefined) {
            this.EmailError = 'Email address is required';
            validState = false;
        } else {
            let EmailEntered: boolean = this.state.email.trim().length > 0;

            if (!EmailEntered) {
                this.EmailError = 'Email address is required';
                validState = false;
            }
        }
        if (!captchatoken) {
            this.recaptchaError = 'Invalid captcha';
            validState = false;
        }
        else {
            this.recaptchaError = '';
        }
        this.setState((prevState: IResetPasswordState): IResetPasswordState => {
            prevState.isValidData = validState;
            return prevState;
        });
        return validState;
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IResetPasswordState, props: IResetPasswordProps): IResetPasswordState => {
            previousState.isValidData = false;
            return previousState;
        });
    }
}